import React, { useState, Fragment } from "react";
import {
  SwipeableDrawer,
  IconButton,
  Box,
  Stack,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
} from "@mui/material";
import { Navbutton } from "./menu.components";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import NavItemContent from "../../common/navContents";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useAlert } from "react-alert";

import "./menu.css";

export default (props) => {
  const alert = useAlert();
  const [cookies, setCookie, removeCookie] = useCookies();
  const [drawerState, setDrawerState] = useState(false);
  const path = "/";
  const domain = window.location.hostname;
  const [internshipOpen, setInternshipOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    setDrawerState(open);
  };

  function clearCookie() {
    setCookie("email", undefined, { path, domain });
    setCookie("firstName", undefined, { path, domain });
    setCookie("lastName", undefined, { path, domain });
    setCookie("userID", undefined, { path, domain });
    setCookie("token", undefined, { path, domain });
    removeCookie("email");
    removeCookie("firstName");
    removeCookie("lastName");
    removeCookie("userID");
    removeCookie("token");
    alert.success("logged out");
    // window.location.reload(false);
  }

  return (
    <Fragment key={"left"}>
      <Stack
        justifyContent="flex-start"
        alignItems="center"
        direction="row"
        sx={{ flexGrow: 1 }}
      >
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          justifyContent="flex-start"
          alignItems="center"
          aria-label="menu"
          sx={{ display: { xs: "inline", lg: "none" } }}
          onClick={toggleDrawer(true)}
        >
          <MenuIcon />
        </IconButton>
      </Stack>
      <SwipeableDrawer
        sx={{ color: "black" }}
        anchor={"left"}
        open={drawerState}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{ height: "100%", width: "300px" }}
        >
          <Stack direction={"column"} pl={3}>
            <CompanyHeader />
            <MenuItems />
          </Stack>
          <LoginButton />
        </Stack>
      </SwipeableDrawer>
    </Fragment>
  );

  function CompanyHeader() {
    return (
      <Box sx={{ mt: 5, mb: 9 }}>
        <Box
          sx={{
            fontSize: 28,
            fontFamily: "Playfair Display",
            fontWeight: "700",
            color: "#229FA4",
          }}
        >
          XPVERSE
        </Box>
      </Box>
    );
  }

  function MenuItems() {
    return (
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        className="menuItem"
      >
        {NavItemContent.general.map((content) => {
          return (
            <ListItemButton sx={{ pl: 0 }} component={Link} to={content.url}>
              <ListItemText primary={content.text} />
            </ListItemButton>
          );
        })}

        <ListItemButton
          sx={{ pl: 0 }}
          onClick={() => setInternshipOpen(!internshipOpen)}
        >
          <ListItemText primary={NavItemContent.dropdown.text} />
          {internshipOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={internshipOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {NavItemContent.dropdown.content.map((data) => {
              return (
                <ListItemButton sx={{ pl: 1 }} component={Link} to={data.url}>
                  <ListItemText primary={data.text} />
                </ListItemButton>
              );
            })}
          </List>
        </Collapse>

        {cookies.token !== undefined && cookies.token !== "undefined" ? (
          <>
            <ListItemButton
              sx={{ pl: 0 }}
              onClick={() => setProfileOpen(!profileOpen)}
            >
              <ListItemText primary="Profile" />
              {profileOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={profileOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {NavItemContent.conditional.map((data) => {
                  return (
                    <ListItemButton
                      sx={{ pl: 1 }}
                      component={Link}
                      to={data.url}
                    >
                      <ListItemText primary={data.text} />
                    </ListItemButton>
                  );
                })}
              </List>
            </Collapse>
          </>
        ) : (
          <></>
        )}
      </List>
    );
  }

  function LoginButton() {
    return (
      <Box sx={{ mb: "50px", pl: 3 }}>
        {cookies.token !== "undefined" && cookies.token !== undefined ? (
          <Navbutton
            sx={{ width: "100%" }}
            underline="none"
            onClick={clearCookie}
          >
            <Stack
              sx={{ width: "100%" }}
              direction={"row"}
              justifyContent={"flex-start"}
              spacing={2}
            >
              <LogoutIcon />
              <Box>{NavItemContent.logout.text}</Box>
            </Stack>
          </Navbutton>
        ) : (
          <Navbutton underline="none" href={NavItemContent.login.url}>
            {NavItemContent.login.text}
          </Navbutton>
        )}
      </Box>
    );
  }
};
